export enum CATEGORY {
  SolarSystem = 'solar-system',
  Flooring = 'flooring',
  Guttering = 'guttering',
  Roofing = 'roofing',
  SolarPoolHeatingSystems = 'solar-pool-heating-systems',
  PoolHeatingSystemsNonSolar = 'pool-heating-systems-non-solar',
  SmartHomeTechnology = 'smart-home-technology',
  TrailersCampers = 'trailers-campers',
  SecuritySystem = 'security-system',
  BatteryStorage = 'battery-storage',
  SolarBatterySystem = 'solar-battery-system',
  OffGridSystem = 'off-grid-system',
  HomeImprovementsOther = 'home-improvements-other',
  GarageDoors = 'garage-doors',
  Awnings = 'awnings',
  BlindsCurtainsShutters = 'blinds-curtains-shutters',
  Plumbing = 'plumbing',
  Electrical = 'electrical',
  Lighting = 'lighting',
  Fireplaces = 'fireplaces',
  OutdoorBlinds = 'outdoor-blinds',
  Landscaping = 'landscaping',
  DrivewaysConcretePaving = 'driveways-concrete-paving',
  VerandahsPatiosPergolas = 'verandahs-patios-pergolas',
  Carports = 'carports',
  Decking = 'decking',
  Sheds = 'sheds',
  Fencing = 'fencing',
  PoolsSpas = 'pools-spas',
  SolarHotWaterSystemsInclHeatPump = 'solar-hot-water-systems-incl-heat-pump',
  HotWaterSystemsElectricGas = 'hot-water-systems-electric-gas',
  AirConditioningVentilation = 'air-conditioning-ventilation',
  EnergyEfficientProducts = 'energy-efficient-products',
  WaterFiltration = 'water-filtration',
  EvChargingInfrastructure = 'ev-charging-infrastructure',
  EfficientElectricStoveTops = 'efficient-electric-stove-tops',
  ElectricHeatingCoolingSystemsReverseCycle = 'electric-heating-cooling-systems-reverse-cycle',
  HotWaterHeatPumpsHwhp = 'hot-water-heat-pumps-hwhp',
  ElectricVehicleNew = 'electric-vehicle-new',
  ElectricVehicleUsed = 'electric-vehicle-used',
  HydronicHeatPumps = 'hydronic-heat-pumps',
  DoubleGlazingWindows = 'double-glazing-windows',
  Insulation = 'insulation',
  EnergyEfficientAppliances = 'energy-efficient-appliances',
  ElectricMotorbikeNew = 'electric-motorbike-new',
  ElectricMotorbikeUsed = 'electric-motorbike-used',
  Inverters = 'inverters',
  MeterUpgrades = 'meter-upgrades',
  ElectricResistanceHotWaterSystem = 'electric-resistance-hot-water-system',
  HeatPumpSpaceHeater = 'heat-pump-space-heater',
  HeatPumpWaterHeater = 'heat-pump-water-heater',
  SwitchboardUpgrade = 'switchboard-upgrade',
  SmartEnergyDevice = 'smart-energy-device',
  InductionCooktop = 'induction-cooktop',
  EvacuatedTubeSolarHotWaterSystem = 'evacuated-tube-solar-hot-water-system',
  EBike = 'e-bike',
  ECargoBike = 'e-cargo-bike',
  SolarBatteryEvCharger = 'solar-battery-ev-charger',
  SolarEvCharger = 'solar-ev-charger',
  BatteryEvCharger = 'battery-ev-charger',
  EvCharger = 'ev-charger',
  PowerSensor = 'powersensor',
}

export const categoryDisplayNames: Record<CATEGORY, string> = {
  'solar-system': 'Solar System',
  flooring: 'Flooring',
  guttering: 'Guttering',
  roofing: 'Roofing',
  'solar-pool-heating-systems': 'Solar Pool Heating Systems',
  'pool-heating-systems-non-solar': 'Pool Heating Systems Non-Solar',
  'smart-home-technology': 'Smart Home Technology',
  'trailers-campers': 'Trailers & Campers',
  'security-system': 'Security System',
  'battery-storage': 'Battery Storage',
  'solar-battery-system': 'Solar and Battery',
  'off-grid-system': 'Off-Grid System',
  'home-improvements-other': 'Home Improvements Other',
  'garage-doors': 'Garage Doors',
  awnings: 'Awnings',
  'blinds-curtains-shutters': 'Blinds, Curtains & Shutters',
  plumbing: 'Plumbing',
  electrical: 'Electrical',
  lighting: 'Lighting',
  fireplaces: 'Fireplaces',
  'outdoor-blinds': 'Outdoor Blinds',
  landscaping: 'Landscaping',
  'driveways-concrete-paving': 'Driveways, Concrete & Paving',
  'verandahs-patios-pergolas': 'Verandahs, Patios & Pergolas',
  carports: 'Carports',
  decking: 'Decking',
  sheds: 'Sheds',
  fencing: 'Fencing',
  'pools-spas': 'Pools & Spas',
  'solar-hot-water-systems-incl-heat-pump': 'Solar Hot Water Systems (incl. Heat Pump)',
  'hot-water-systems-electric-gas': 'Hot Water Systems (Electric & Gas)',
  'air-conditioning-ventilation': 'Air Conditioning & Ventilation',
  'energy-efficient-products': 'Energy Efficient Products',
  'water-filtration': 'Water Filtration',
  'ev-charging-infrastructure': 'EV Charging Infrastructure',
  'efficient-electric-stove-tops': 'Efficient Electric Stove Tops',
  'electric-heating-cooling-systems-reverse-cycle': 'Electric Heating & Cooling Systems (Reverse Cycle)',
  'hot-water-heat-pumps-hwhp': 'Hot Water Heat Pumps (HWHP)',
  'electric-vehicle-new': 'Electric Vehicle (New)',
  'electric-vehicle-used': 'Electric Vehicle (Used)',
  'hydronic-heat-pumps': 'Hydronic Heat Pumps',
  'double-glazing-windows': 'Double Glazing Windows',
  insulation: 'Insulation',
  'energy-efficient-appliances': 'Energy Efficient Appliances',
  'electric-motorbike-new': 'Electric Motorbike (New)',
  'electric-motorbike-used': 'Electric Motorbike (Used)',
  inverters: 'Inverters',
  'meter-upgrades': 'Meter Upgrades',
  'smart-energy-device': 'Smart Energy Device',
  'electric-resistance-hot-water-system': 'Electric Resistance Hot Water System',
  'heat-pump-space-heater': 'Heat Pump Space Heater',
  'heat-pump-water-heater': 'Heat Pump Water Heater',
  'switchboard-upgrade': 'Switchboard Upgrade',
  'induction-cooktop': 'Induction Cooktop',
  'evacuated-tube-solar-hot-water-system': 'Evacuated Tube Solar Hot Water System',
  'e-bike': 'E-Bike',
  'e-cargo-bike': 'E-Cargo Bike',
  'solar-battery-ev-charger': 'Solar, Battery & EV Charger',
  'solar-ev-charger': 'Solar & EV Charger',
  'battery-ev-charger': 'Battery & EV Charger',
  'ev-charger': 'EV Charger',
  powersensor: 'Powersensor Energy Monitor',
};

export const e2515Categories: CATEGORY[] = [
  CATEGORY.SwitchboardUpgrade,
  CATEGORY.HeatPumpWaterHeater,
  CATEGORY.InductionCooktop,
  CATEGORY.SmartEnergyDevice,
  CATEGORY.ElectricResistanceHotWaterSystem,
  CATEGORY.ElectricHeatingCoolingSystemsReverseCycle,
  CATEGORY.PowerSensor,
];
